WiseMetering.Model.RootObject = WiseMetering.Model.extend({
    site: function() {
        return WiseMetering.zones.get(this.get('site_id'));
    },

    children: function() {
        let site = WiseMetering.zones.get(this.get('site_id'));
        return site.children(this.get('slug'));
    },

    circuits: function() {
        return this.site().circuits();
    },

    folders: function() {
        return this.site().folders();
    },

    inactiveTenants: function() {
        return this.site().inactiveTenants();
    },

    icon: function() {
        return this.get('slug');
    },

    isAvailable: function() {
        return WiseMetering.Permissions.hasPlanPermissions(this.get('slug'));
    },

    nodeUrl: function(skipSearch) {
        return `/root_objects/${this.id}${skipSearch ? '' : location.search}`;
    },

    parent: function() {
        return this.site();
    },

    seus: function() {
        return this.site().seus();
    },

    slug: function() {
        return this.get('name').toLowerCase();
    },

    tenants: function() {
        return this.site().tenants();
    },

    type: function() {
        return 'root-object';
    },

    utilities: function() {
        return this.site().utilities();
    },

    zones: function() {
        return this.site().zones();
    }
});
